import React from "react";
import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import Breadcrumbs, { toLdItems } from "@/components/Breadcrumbs";
import { buildBreadcrumbLd } from "@/lib/seo";
import { useSeoT } from "@/lib/seoPagesI18n";

// NOINDEX tant que les données réelles de l'étude fournie ne sont pas intégrées.
export default function BarometreVaud2026() {
  const { t: st } = useSeoT();
  const bt = st.barometre;
  const path = "/etudes/barometre-prix-demenagement-vaud-2026";
  const bc = [
    { name: st.bc.home, path: "/" },
    { name: st.bc.etudes, path: "/etudes" },
    { name: bt.bcCrumb, path },
  ];
  return (
    <div className="min-h-screen bg-white text-[#0A0F2C]" data-testid="barometre-vaud-2026">
      <Seo title={bt.seoTitle} description={bt.seoDesc} path={path} noindex jsonLd={buildBreadcrumbLd(toLdItems(bc))} />
      <Header />
      <section className="relative bg-[#2D5BFF] hero-noise overflow-hidden pt-28 md:pt-36 pb-14 md:pb-16 px-5 sm:px-8 md:px-10 lg:px-14 text-white">
        <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(ellipse at top right, rgba(255,255,255,0.15), transparent 55%)" }} />
        <div className="relative mx-auto" style={{ maxWidth: "900px" }}>
          <div className="mb-6"><Breadcrumbs items={bc} variant="dark" /></div>
          <h1 className="font-extrabold text-3xl md:text-5xl tracking-tighter leading-[1.03]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{bt.h1}</h1>
          <p className="mt-5 text-white/85 text-base md:text-lg">{bt.heroSub}</p>
        </div>
      </section>
      <section className="py-14 md:py-20 px-5 sm:px-8 md:px-10 lg:px-14 bg-white">
        <div className="mx-auto" style={{ maxWidth: "900px" }}>
          <div className="rounded-2xl bg-[#FFF8DC] border border-[#F1E4A0] p-5 flex items-start gap-3" data-testid="barometre-pending">
            <Info size={18} className="text-[#A88A00] shrink-0 mt-0.5" />
            <p className="text-sm text-[#5b4a00] leading-relaxed">{bt.pending}</p>
          </div>
          <h2 className="mt-10 font-extrabold text-2xl tracking-tight" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{bt.structureTitle}</h2>
          <ol className="mt-5 flex flex-col gap-2.5 list-decimal list-inside text-[#374151] text-[17px]">
            {bt.structure.map((s, i) => (<li key={i}>{s}</li>))}
          </ol>
          <p className="mt-8 text-sm text-[#6B7280]">← <Link to="/etudes" className="font-semibold hover:text-[#0A0F2C]">{bt.allStudies}</Link></p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
